import type {
	LifeInsuranceDetailDataDTO,
	PortfolioDetailResponseDTO,
} from "web_myplann/Infrastructure/Api/Api";
import { parseIsoDate } from "web_myplann/Portfolio/Forms/dateParsers";
import { mapInvestmentToolsToForm } from "web_myplann/Portfolio/Forms/InvestmentForm/Mappers/mapInvestmentToolsToForm";
import { mapInsuredPersonsToForm } from "web_myplann/Portfolio/Forms/LifeInsuranceForm/InsuredPersons/mapInsuredPersons";
import { LIFE_INSURANCE_FORM_DEFAULT_VALUES as DEFAULTS } from "web_myplann/Portfolio/Forms/LifeInsuranceForm/lifeInsuranceFormDefaults";
import type { LifeInsuranceFormInput } from "web_myplann/Portfolio/Forms/LifeInsuranceForm/lifeInsuranceFormSchema";
import type { TranslateFunction } from "web_myplann/Shared/TranslateFunction";

export const mapPortfolioToLifeInsuranceForm = (
	portfolio: PortfolioDetailResponseDTO,
	t: TranslateFunction,
): LifeInsuranceFormInput => {
	const data = portfolio.data as LifeInsuranceDetailDataDTO | undefined;

	return {
		name: portfolio.name ?? DEFAULTS.name,
		contractNumber: portfolio.contractNumber ?? DEFAULTS.contractNumber,
		producer: portfolio.producer ?? DEFAULTS.producer,
		product: portfolio.product ?? DEFAULTS.product,
		insurance: data?.insurance ?? DEFAULTS.insurance,
		paymentFrequency: data?.paymentFrequency ?? DEFAULTS.paymentFrequency,
		employerContribution:
			data?.employerContribution ?? DEFAULTS.employerContribution,
		insuredPersons: mapInsuredPersonsToForm(data?.insuredPersons),
		tools: mapInvestmentToolsToForm(portfolio.tools, t),
		value: DEFAULTS.value,
		invested: DEFAULTS.invested,
		valueDate: DEFAULTS.valueDate,
		signedAt: parseIsoDate(portfolio.signedAt),
		startAt: parseIsoDate(portfolio.startAt),
		endAt: parseIsoDate(portfolio.endAt),
	};
};
